import React, { type ReactNode } from 'react';

import { cssMap } from '@atlaskit/css';
import { Box, Inline } from '@atlaskit/primitives/compiled';
import { token } from '@atlaskit/tokens';

const textWrapperStyles = cssMap({
	root: {
		whiteSpace: 'nowrap',
		overflow: 'hidden',
		textOverflow: 'ellipsis',
	},
});

const featureLineStyles = cssMap({
	root: {
		height: '24px',
		maxWidth: '165px',
		gap: token('space.100'),
		alignItems: 'center',
	},
});

/**
 * Shows an icon and feature name so as to depict a feature being compared.
 */
export const FeatureRow = ({
	icon,
	name,
	keyName,
}: {
	icon: ReactNode;
	keyName: string;
	name: string;
}): React.JSX.Element => (
	<Inline key={keyName} xcss={featureLineStyles.root}>
		{icon}
		<Box xcss={textWrapperStyles.root} key={`wrapper-${keyName}`}>
			{name}
		</Box>
	</Inline>
);
